import { thunk } from 'easy-peasy';
import api from '~/services/api';
import { IThunkCreateCarePlanMedications } from '../types';

const onCreateCarePlanMedications: IThunkCreateCarePlanMedications = thunk(
  // @ts-ignore
  async ({ addCarePlanMedications }, payload) => {
    const { patientId, data } = payload;
    const carePlanMedications = await api.carePlanMedications
      .create(patientId, data)
      .then(res => res.data);
    addCarePlanMedications(carePlanMedications);
  },
);

export default onCreateCarePlanMedications;
